import { Component } from '@angular/core';
import { SignalRService } from './core/services/signal-r.service';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  titlePageHebrew: string = "חניונים אוטונומיים | שקמה ידע וטכנולוגיה בע&quot;מ | חולון";
  titlePageEnglish: string = "Shikma N&T";

  constructor(
    public signalRService: SignalRService,
    private http: HttpClient,
    private translate: TranslateService,
    private titleService: Title) {
      translate.addLangs(['il', 'en']);
      translate.setDefaultLang('il');

      const browserLang = translate.getBrowserLang() === "il" ? "il" : "en";
      browserLang === "il" ? this.setTitle(this.titlePageHebrew) : this.setTitle(this.titlePageEnglish);
			translate.use(browserLang.match(/il|en/) ? browserLang : 'en');
  }

  public setTitle( newTitle: string) {
    this.titleService.setTitle( newTitle );
  }
 
  ngOnInit() {
  }

}
